import React from "react";
import qrSectionBgFallback from "../assets/img/qr-section.png";
import qrImageFallback from "../assets/img/qr.png";

const DEFAULT_BUTTON_URL =
  "https://drive.google.com/file/d/1t_-M9Qi7aLLzQPDx1ZW1P0qbrvzwF8J4/preview";

const normalizeImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("/")) return url;
  return `/${url}`;
};

const DocumentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M26 19V15.5C26 14.3065 25.5259 13.1619 24.682 12.318C23.8381 11.4741 22.6935 11 21.5 11H19.5C19.1022 11 18.7206 10.842 18.4393 10.5607C18.158 10.2794 18 9.89782 18 9.5V7.5C18 6.30653 17.5259 5.16193 16.682 4.31802C15.8381 3.47411 14.6935 3 13.5 3H11M14 3H7.5C6.672 3 6 3.672 6 4.5V27.5C6 28.328 6.672 29 7.5 29H24.5C25.328 29 26 28.328 26 27.5V15C26 11.8174 24.7357 8.76516 22.4853 6.51472C20.2348 4.26428 17.1826 3 14 3Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.83368 11.3336V10.6666C1.83368 10.2064 2.20645 9.83362 2.66669 9.83362C3.12692 9.83362 3.49969 10.2064 3.49969 10.6666V11.3336C3.49978 11.6428 3.62298 11.9392 3.84149 12.1578C4.06028 12.3766 4.35727 12.4996 4.66669 12.4996H11.3337C11.643 12.4995 11.9392 12.3766 12.1579 12.1578C12.3766 11.9391 12.4996 11.6429 12.4997 11.3336V10.6666C12.4997 10.2064 12.8734 9.83362 13.3337 9.83362C13.7938 9.83379 14.1667 10.2065 14.1667 10.6666V11.3336C14.1666 12.0849 13.8679 12.8053 13.3366 13.3365C12.8053 13.8678 12.085 14.1665 11.3337 14.1666H4.66669C3.91524 14.1666 3.19413 13.8679 2.66278 13.3365C2.13171 12.8053 1.83377 12.0848 1.83368 11.3336ZM7.16669 2.66663C7.16669 2.2065 7.53961 1.83379 7.99969 1.83362C8.45993 1.83362 8.83368 2.20639 8.83368 2.66663V8.65491L10.0778 7.41077C10.4032 7.08555 10.9302 7.08555 11.2556 7.41077C11.581 7.7362 11.581 8.26404 11.2556 8.58948L8.58954 11.2555C8.2641 11.5809 7.73626 11.5809 7.41083 11.2555L4.74384 8.58948C4.41845 8.26409 4.41856 7.73622 4.74384 7.41077C5.06927 7.08533 5.59711 7.08533 5.92255 7.41077L7.16669 8.65491V2.66663Z"
      fill="#2E3192"
    />
  </svg>
);

const AdvertiseGetDetails = ({ details }) => {
  if (!details) return null;

  const data = details.data || {};

  const heading = data.heading || "Get Our Advertising Details";
  const subtitle =
    data.subtitle ||
    "Explore our complete advertising opportunities, formats and pricing in our detailed advertising document.";
  const backgroundImage = data.background_image
    ? normalizeImageUrl(data.background_image)
    : qrSectionBgFallback;
  const qrImage = data.qr_image
    ? normalizeImageUrl(data.qr_image)
    : qrImageFallback;
  const qrCaption =
    data.qr_caption || "Scan to view the detailed advertising document";
  const pdfLabel = data.pdf_label || "PDF Document";
  const pdfTitle = data.pdf_title || "Detailed Advertising Guide";
  const pdfDescription =
    data.pdf_description ||
    "All formats, specifications, placement options and everything needed to plan your campaign.";
  const buttonText = data.button_text || "Download Detailed Document";
  const buttonUrl = data.button_url || DEFAULT_BUTTON_URL;

  return (
    <div
      className="ad-details-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="container">
        <div className="ad-details-header">
          <h2>{heading}</h2>
          <p>{subtitle}</p>
        </div>

        <div className="ad-action-container">
          <div className="ad-action-card-qr">
            <img src={qrImage} alt="QR code for advertising document" />
            <span>{qrCaption}</span>
          </div>

          <div className="ad-divider">or</div>

          <div className="ad-action-card">
            <div>
              <div className="ad-icon-badge">
                <DocumentIcon />
              </div>
              <div className="ad-card-badge-label">{pdfLabel}</div>
              <div className="ad-card-title">{pdfTitle}</div>
              <p className="ad-card-desc">{pdfDescription}</p>
            </div>
            <a
              href={buttonUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="ad-btn-white"
            >
              <DownloadIcon />
              {buttonText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertiseGetDetails;
